<template>
  <div class="card card-icon mb-4">
    <div class="row no-gutters">
      <!-- Icon -->
      <div
        class="d-none
            d-md-flex
            col-auto
            card-icon-aside
            bg-primary
            text-white"
      >
        <i data-feather="dollar-sign"></i>
      </div>

      <div class="col">
        <div class="card-body py-4">
          <h3 class="card-title">
            <span :class="isEditingResource ? 'text-danger' : ''">{{ titleForm }}</span>
          </h3>

          <div class="card-text">
            <FormulateForm
              ref="catalogoPartidasForm"
              @submit="submit"
              #default="{ hasErrors, isLoading }"
            >
              <b-row>
                <!-- Periodo fiscal -->
                <b-col cols="12" md="12" lg="6">
                  <FormulateInput
                    name="periodo_fiscal"
                    v-model="formValues.periodo_fiscal_id"
                    :disabled="isLoading"
                    validation="bail|required"
                    error-behavior="live"
                    :validation-messages="{
                      required: 'El periodo fiscal es requerido'
                    }"
                  >
                    <template #element>
                      <x-form-group title="Periodo fiscal" required>
                        <check-authorization
                          :requiresAuthorizations="['listar periodos fiscales']"
                          :show-alert="false"
                          no-slots
                          #default="{ authorized }"
                        >
                          <x-select
                            v-model="formValues.periodo_fiscal_id"
                            dispatchPath="fiscalPeriodsModule/getFiscalPeriods"
                            getterListPath="fiscalPeriodsModule/getAllFiscalPeriods"
                            :formatListWith="['id', 'nombre']"
                            :disabled="!authorized || isLoading"
                            no-validate
                            no-prepend
                          ></x-select>
                        </check-authorization>
                      </x-form-group>
                    </template>
                  </FormulateInput>
                </b-col>

                <!-- Estatus -->
                <b-col cols="12" md="12" lg="6">
                  <x-form-group title="Estatus">
                    <b-form-select
                      :value="formValues.estatus.value"
                      v-model="formValues.estatus"
                      :options="[
                        { text: 'Activo', value: 1 },
                        { text: 'Inactivo', value: 0 }
                      ]"
                    ></b-form-select>
                  </x-form-group>
                </b-col>

                <!-- Clave -->
                <b-col cols="12" md="12" lg="6">
                  <x-form-group title="Clave" required>
                    <FormulateInput
                      v-model="formValues.clave"
                      :disabled="isLoading"
                      placeholder="Ingresa el número de clave"
                      validation="bail|required|max:100,length"
                      :validation-messages="{
                        required: 'El número de clave es requerido',
                        max: 'La longitud máxima es de 100 caracteres'
                      }"
                    />
                  </x-form-group>
                </b-col>

                <!-- Nombre -->
                <b-col cols="12" md="12" lg="6">
                  <x-form-group title="Nombre" required>
                    <FormulateInput
                      v-model="formValues.nombre"
                      :disabled="isLoading"
                      placeholder="Ingresa el nombre de la partida"
                      validation="bail|required|max:255,length"
                      :validation-messages="{
                        required: 'El nombre de la partida es requerido',
                        max: 'La longitud máxima es de 255 caractéres'
                      }"
                    />
                  </x-form-group>
                </b-col>
              </b-row>

              <!-- Enviar para crear o actualizar -->
              <x-form-footer-buttons
                :disabled="hasErrors || isLoading"
                :loading="isLoading"
                :isEditing="isEditing"
                :isCreating="!isEditing"
                @on-cancel="resetForm"
                @on-click-create="submit"
                @on-click-update="submit"
              />
            </FormulateForm>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

const formValues = () => ({
  nombre: '',
  clave: '',
  estatus: '',
  periodo_fiscal_id: ''
})

export default {
  name: 'PartidaForm',

  data () {
    return {
      formValues: formValues(),

      isEditing: false
    }
  },

  computed: {
    ...mapGetters('partidaModule', ['isEditingResource']),

    ...mapGetters('fiscalPeriodsModule', ['getFiscalPeriodsForForms']),

    ...mapState('partidaModule', ['currentPartida']),

    titleForm () {
      return this.isEditingResource
        ? `Editando partida: ${this.currentPartida.nombre}`
        : 'Crear partida'
    }
  },

  watch: {
    currentPartida: {
      deep: true,
      immediate: true,
      handler (currentPartida) {
        this.isEditing = Boolean(currentPartida)

        if (this.isEditing) {
          this.formValues = currentPartida
          return
        }

        this.resetForm()
      }
    }
  },

  methods: {
    emitOnHideForm () {
      this.$emit('hide-form')
    },

    emitOnSubmitted () {
      this.$emit('submitted')
    },

    async submit () {
      const getval = this.isEditing
        ? await this.update(this.formValues)
        : await this.create(this.formValues)

      if (getval.error) return this.$notify(getval, 'Envío de formulario')

      this.emitOnSubmitted()
      this.resetForm()
    },

    async create (form) {
      return await this.$store.dispatch('partidaModule/create', form)
    },

    async update (form) {
      return await this.$store.dispatch('partidaModule/update', {
        id: form.id,
        payload: form
      })
    },

    resetForm () {
      document.activeElement.blur()
      this.$store.commit('partidaModule/setCurrentPartida', null)
      this.formValues = formValues()
      if (this.$refs.catalogoPartidasForm) {
        this.$refs.catalogoPartidasForm.hideErrors()
        this.emitOnHideForm()
      }
      window.scrollTo(0, 0)
    }
  }
}
</script>
